"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable max-len */
var react_1 = __importDefault(require("react"));
var BluetoothOn = function (_a) {
    var size = _a.size, title = _a.title, color = _a.color, svgProps = __rest(_a, ["size", "title", "color"]);
    return (react_1.default.createElement("svg", __assign({ stroke: "currentcolor", fill: "currentColor", strokeWidth: "0" }, svgProps, { width: size || '1rem', height: size || '1rem', viewBox: "0 0 24 24", style: __assign({ color: color }, svgProps.style), xmlns: "http://www.w3.org/2000/svg" }),
        title && react_1.default.createElement("title", null, title),
        react_1.default.createElement("g", { id: "bluetooth-on" },
            react_1.default.createElement("path", { id: "Icon", d: "M6.64018 6.23178C6.21591 5.87821 5.58534 5.93554 5.23178 6.35982C4.87821 6.78409 4.93554 7.41466 5.35982 7.76822L6.64018 6.23178ZM18 17L18.6402 17.7682C18.8682 17.5782 19 17.2968 19 17C19 16.7032 18.8682 16.4218 18.6402 16.2318L18 17ZM12 22H11C11 22.388 11.2245 22.741 11.5758 22.9056C11.9272 23.0702 12.3421 23.0166 12.6402 22.7682L12 22ZM12 2L12.6402 1.23178C12.3421 0.983376 11.9272 0.929831 11.5758 1.09441C11.2245 1.25899 11 1.61198 11 2L12 2ZM18 7L18.6402 7.76822C18.8682 7.57823 19 7.29678 19 7C19 6.70322 18.8682 6.42177 18.6402 6.23178L18 7ZM5.35982 16.2318C4.93554 16.5853 4.87821 17.2159 5.23178 17.6402C5.58534 18.0645 6.21591 18.1218 6.64018 17.7682L5.35982 16.2318ZM5.35982 7.76822L17.3598 17.7682L18.6402 16.2318L6.64018 6.23178L5.35982 7.76822ZM17.3598 16.2318L11.3598 21.2318L12.6402 22.7682L18.6402 17.7682L17.3598 16.2318ZM13 22V2H11V22H13ZM11.3598 2.76822L17.3598 7.76822L18.6402 6.23178L12.6402 1.23178L11.3598 2.76822ZM17.3598 6.23178L5.35982 16.2318L6.64018 17.7682L18.6402 7.76822L17.3598 6.23178Z" }))));
};
exports.default = BluetoothOn;
